import { Plus, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const Add = ({ onClick, testId }) => (
  <button data-testid={testId} onClick={onClick} className="flex items-center gap-1 text-xs text-zinc-400 hover:text-amber-400"><Plus className="h-3.5 w-3.5" /> Adaugă</button>
);
const Del = ({ onClick, testId }) => (
  <button data-testid={testId} onClick={onClick} className="mt-1.5 text-zinc-500 hover:text-rose-400"><X className="h-4 w-4" /></button>
);

export const StringList = ({ value = [], onChange, testId, placeholder }) => (
  <div className="space-y-1.5">
    {value.map((v, i) => (
      <div key={i} className="flex gap-1.5">
        <Input data-testid={`${testId}-${i}`} value={v} placeholder={placeholder} onChange={(e) => onChange(value.map((x, j) => (j === i ? e.target.value : x)))} className="h-8 text-xs" />
        <Del testId={`${testId}-del-${i}`} onClick={() => onChange(value.filter((_, j) => j !== i))} />
      </div>
    ))}
    <Add testId={`${testId}-add`} onClick={() => onChange([...value, ""])} />
  </div>
);

export const ObjectList = ({ value = [], onChange, fields, testId }) => (
  <div className="space-y-2">
    {value.map((v, i) => (
      <div key={i} className="flex gap-1.5 rounded-lg border border-zinc-800 p-2">
        <div className="flex-1 space-y-1.5">
          {fields.map(([k, label, long]) => {
            const set = (e) => onChange(value.map((x, j) => (j === i ? { ...x, [k]: e.target.value } : x)));
            return long
              ? <Textarea key={k} data-testid={`${testId}-${i}-${k}`} value={v[k] || ""} placeholder={label} onChange={set} rows={2} className="text-xs" />
              : <Input key={k} data-testid={`${testId}-${i}-${k}`} value={v[k] || ""} placeholder={label} onChange={set} className="h-8 text-xs" />;
          })}
        </div>
        <Del testId={`${testId}-del-${i}`} onClick={() => onChange(value.filter((_, j) => j !== i))} />
      </div>
    ))}
    <Add testId={`${testId}-add`} onClick={() => onChange([...value, Object.fromEntries(fields.map(([k]) => [k, ""]))])} />
  </div>
);

export const SectionFields = ({ k, v, set }) => {
  if (k === "hero") {
    const h = v || {};
    return (
      <div className="space-y-2">
        <Input data-testid="hero-headline" value={h.headline || ""} onChange={(e) => set({ ...h, headline: e.target.value })} placeholder="Titlu principal" />
        <Textarea data-testid="hero-sub" value={h.subheadline || ""} onChange={(e) => set({ ...h, subheadline: e.target.value })} rows={2} placeholder="Subtitlu" className="text-xs" />
        <p className="text-[11px] text-zinc-500">Beneficii scurte (cu bifă)</p>
        <StringList testId="hero-bullet" value={h.bullets} onChange={(b) => set({ ...h, bullets: b })} />
      </div>
    );
  }
  if (k === "benefits") return <ObjectList testId="benefit" value={v} onChange={set} fields={[["title", "Titlu"], ["text", "Text", true]]} />;
  if (k === "faq") return <ObjectList testId="faq" value={v} onChange={set} fields={[["q", "Întrebare"], ["a", "Răspuns", true]]} />;
  if (k === "reviews") return <ObjectList testId="review" value={v} onChange={set} fields={[["author", "Prenume"], ["text", "Recenzie", true]]} />;
  if (k === "usage") {
    const u = v || {};
    const specs = (u.specs || []).map(([a, b]) => ({ k: a, v: b }));
    return (
      <div className="space-y-2">
        <p className="text-[11px] text-zinc-500">Pași de folosire</p>
        <StringList testId="usage-step" value={u.steps} onChange={(st) => set({ ...u, steps: st })} />
        <p className="text-[11px] text-zinc-500">Specificații</p>
        <ObjectList testId="spec" value={specs} onChange={(rows) => set({ ...u, specs: rows.map((r) => [r.k, r.v]) })} fields={[["k", "Caracteristică"], ["v", "Valoare"]]} />
      </div>
    );
  }
  return null;
};
